import axios from "axios";
import { BACKEND_URL } from "../constants/Constant";

const BASE_URL = `${BACKEND_URL}/contact`;

export const contactUs = async (payload) => {
  try {
    const response = await axios.post(`${BASE_URL}/post-contact`, payload);
    return response.data;
  } catch (error) {
    console.error("Error Posting Contact: ", error);
    throw error;
  }
};
